import React from 'react';

import { faCity } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@mui/material';

import APISelect from '../components/APISelect';
import StrongTextField from '../components/StrongTextField';

export default {
  title: 'Villes',
  name: 'villes',
  icon: faCity,
  resource: 'ville_insee',
  primaryKey: 'ville_insee_id',
  sort: 'ville_insee_nom',
  query: { _associations: 'fiscalite' },
  head: {
    ville_insee_nom: 'Nom',
    ville_insee_nom2: 'Nom 2',
    ville_insee_nom_dept: 'Departement',
    ville_insee_code_dept: 'Departement',
    ville_insee_cp: 'Code postal',
    ville_insee_nom_region: 'Region',
    ville_insee_code_insee: 'Code INSEE',
    ville_insee_fiscalite_zones_idzone: 'Zone',
  },
  filter: ({ values, props }) => [
    <StrongTextField suffix='%' name='ville_insee_nom' label='Nom' value={values.ville_insee_nom} {...props} />,
    <StrongTextField suffix='%' name='ville_insee_cp' label='Code postal' value={values.ville_insee_cp} {...props} />,
  ],
  list: ({ values }) => [
    values.ville_insee_nom,
    values.ville_insee_nom2,
    values.ville_insee_nom_dept,
    values.ville_insee_code_dept,
    values.ville_insee_cp,
    values.ville_insee_nom_region,
    values.ville_insee_code_insee,
    values.fiscalite?.etiquette,
  ],
  edit: ({ values, props, handleChange, handleSubmit }) => [
    <TextField {...props} fullWidth name='ville_insee_nom' label='Nom' value={values.ville_insee_nom} />,
    <TextField {...props} fullWidth name='ville_insee_nom2' label='Nom 2' value={values.ville_insee_nom2} />,
    <TextField
      {...props}
      fullWidth
      name='ville_insee_nom_dept'
      label='Departement'
      value={values.ville_insee_nom_dept}
    />,
    <TextField
      {...props}
      fullWidth
      name='ville_insee_code_dept'
      label='Departement (code)'
      value={values.ville_insee_code_dept}
    />,
    <TextField {...props} fullWidth name='ville_insee_cp' label='Code postal' value={values.ville_insee_cp} />,
    <TextField
      {...props}
      fullWidth
      name='ville_insee_nom_region'
      label='Nom region'
      value={values.ville_insee_nom_region}
    />,
    <TextField
      {...props}
      fullWidth
      name='ville_insee_code_insee'
      label='Code INSEE'
      value={values.ville_insee_code_insee}
    />,
    <APISelect
      {...props}
      fullWidth
      resource='fiscalite_zones'
      name='ville_insee_fiscalite_zones_idzone'
      value={values.ville_insee_fiscalite_zones_idzone}
      valueAttribute='idzone'
      renderAttribute='etiquette'
      label='Zone de fiscalité'
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />,
  ],
  add: true,
  popup: true,
  remove: true,
};
